export const MAIN_PAGE_DATA = 'MAIN_PAGE_DATA'
export const BEST_SPECIALIZATIONS = 'BEST_SPECIALIZATIONS'
export const BEST_COMPANIES = 'BEST_COMPANIES'
export const BEST_FREELANCER = 'BEST_FREELANCER'
export const BEST_WORKER = 'BEST_WORKER'
export const BEST_SPECIALIST = 'BEST_SPECIALIST'
export const BLOG_KEY = 'BLOG_KEY'
export const ADS_DATA = 'ads_data'
export const TRANSLATE = 'TRANSLATE'
